import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { AuthProvider } from './lib/auth.js'
import { BrandingProvider } from './lib/branding.js'
import { setAcademySuspendedHandler } from './lib/api.js'
import { ErrorBoundary } from './components/ErrorBoundary.js'
import { routeTree } from './routeTree.gen'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
})

// When any API call is rejected with ACADEMY_SUSPENDED, refetch `me` so the
// suspended/cancelled lockout screen engages right away.
setAcademySuspendedHandler(() => {
  void queryClient.invalidateQueries({ queryKey: ['me'] })
})

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { queryClient },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Missing #root element')

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrandingProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </BrandingProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
